import { api } from "./client";

export type ThreadTier = "important" | "normal" | "unimportant" | "unknown";

export type ThreadSummary = {
  id: string;
  gmailThreadId: string;
  subject: string | null;
  snippet: string | null;
  lastMessageAt: string | null;
  isRead: boolean;
  from: { email: string; name: string | null; tier: ThreadTier } | null;
};

export type Attachment = {
  filename: string;
  mimeType: string;
  size: number;
  attachmentId: string;
  partId?: string;
  inline?: boolean;
  contentId?: string | null;
};

export type ThreadMessage = {
  id: string;
  gmailMessageId: string;
  fromEmail: string;
  toEmails: string[];
  ccEmails: string[];
  subject: string | null;
  body: string | null;
  bodyHtml: string | null;
  attachments: Attachment[];
  snippet: string | null;
  isRead: boolean;
  isSent: boolean;
  labels: string[];
  receivedAt: string;
  from: { email: string; name: string | null; tier: ThreadTier };
};

export type ThreadDetail = {
  id: string;
  gmailThreadId: string;
  subject: string | null;
  messages: ThreadMessage[];
};

export function listThreads(
  options: {
    tier?: "all" | ThreadTier;
    limit?: number;
    q?: string;
    cursor?: string | null;
  } = {},
): Promise<{ threads: ThreadSummary[]; nextCursor: string | null }> {
  const params = new URLSearchParams({
    tier: options.tier ?? "all",
    limit: String(options.limit ?? 50),
  });
  if (options.q) params.set("q", options.q);
  if (options.cursor) params.set("cursor", options.cursor);
  return api(`/threads?${params}`);
}

export function getThread(id: string): Promise<{ thread: ThreadDetail }> {
  return api(`/threads/${id}`);
}

export function triggerSync(): Promise<{ newMessages: unknown[]; updatedThreads: number }> {
  return api(`/threads/sync`, { method: "POST" });
}

export function archiveThread(id: string): Promise<{ ok: true }> {
  return api(`/threads/${id}/archive`, { method: "POST" });
}

export function markThreadRead(id: string): Promise<{ ok: true }> {
  return api(`/threads/${id}/mark-read`, { method: "POST" });
}

export function markThreadUnread(id: string): Promise<{ ok: true }> {
  return api(`/threads/${id}/mark-unread`, { method: "POST" });
}
